@if (createNewForm) {
	<form [formGroup]="createNewForm">
		<div class="grid grid-cols-2 gap-4 gap-y-0">
			<!--  Form Type -->
			<app-cbta-autocomplete
				[label]="'Form Type'"
				[data]="formType.value"
				[placeholder]="'Form Type'"
				[options]="sharedService.dropDownFormTypeOptions"
				(focusOut)="onFormTypeSelected($event)"
				[field]="formType"
				[clearable]="true"
			></app-cbta-autocomplete>

			<!--  Form Name -->
			<div class="form-element">
				<mat-label for="form-name">Test Name</mat-label>
				<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
					<input type="text" formControlName="formName" matInput placeholder="Test Name" />
					@if (formName.errors) {
						<mat-error>{{ sharedService.getErrorMessage(formName) }}</mat-error>
					}
				</mat-form-field>
			</div>

			<!-- Dates -->
			<app-cbta-datepicker
				[inputDesign]="'formType'"
				label="Test Start Date"
				placeHolder="DD MMM YYYY"
				[format]="DATE_FORMAT.INPUT_DISPLAY_DATE_FORMAT"
				[minDate]="today"
				[defaultValue]="trainingStartDate"
				(selectedDateChange)="handleStartDateChange($event)"
			></app-cbta-datepicker>

			<app-cbta-datepicker
				[inputDesign]="'formType'"
				label="Test End Date"
				placeHolder="DD MMM YYYY"
				[format]="DATE_FORMAT.INPUT_DISPLAY_DATE_FORMAT"
				[defaultValue]="trainingEndDate"
				[minDate]="today"
				(selectedDateChange)="handleEndDateChange($event)"
			></app-cbta-datepicker>
		</div>

		@if (formConfigReady) {
			<!-- Session Configuration -->
			<section class="ts1-form-section">
				<div class="ts1-form-section__header">Session Configuration</div>
			</section>
			<div [formGroup]="sessions" class="px-0 py-6 lg:px-6" id="session-checkboxes">
				<p class="mb-4">Please select relevant session. Instructor can select more than <strong>ONE(1)</strong>.</p>

				<!-- TS-1: flat 4-column grid, alphabetical -->
				@if (isTS1) {
					<app-ets1-aoc-session-config
						[sessions]="sessions"
						[sessionRemarks]="sessionRemarks"
						[columns]="ets1SessionColumns"
					></app-ets1-aoc-session-config>
					@if (hasSessionRemarkRequiredErrors) {
						<div class="mt-2 text-sm text-red">
							Please enter required details for the selected sessions marked with Edit *.
						</div>
					}
					@if (hasEts1RadioRequiredErrors) {
						<div class="mt-2 text-sm text-red">
							Please select one radio option for each multi-option session (e.g. LPC/OPC/Skill Test).
						</div>
					}
				} @else if (isEts35SessionCatalog) {
					<app-ets1-aoc-session-config
						[sessions]="sessions"
						[sessionRemarks]="sessionRemarks"
						[columns]="[]"
						[sections]="ets35SessionSections"
					></app-ets1-aoc-session-config>
					@if (hasSessionRemarkRequiredErrors) {
						<div class="mt-2 text-sm text-red">
							Please enter required details for the selected training sessions marked with Edit *.
						</div>
					}
					@if (hasEts1RadioRequiredErrors) {
						<div class="mt-2 text-sm text-red">
							Please select one radio option for each multi-option training session.
						</div>
					}
				} @else if (sessionGroups.length === 1) {
					<div class="grid grid-cols-1 gap-x-16 gap-y-3 sm:grid-cols-4 lg:grid-cols-4">
						@for (col of singleCols; track $index) {
							<div class="flex flex-col gap-3">
								@for (s of col; track s.code) {
									<mat-checkbox [formControlName]="s.code" color="primary">
										{{ s.description }}
									</mat-checkbox>
								}
							</div>
						}
					</div>
				} @else if (sessionGroups.length === 3 && twoGroupsCompact) {
					<div class="grid grid-cols-1 gap-x-12 gap-y-6 sm:grid-cols-4 lg:grid-cols-4">
						<!-- Left -->
						<div>
							<div class="mb-2 font-semibold">{{ twoColsLeft?.key }}</div>
							<div class="flex flex-col gap-3">
								@for (s of twoColsLeft?.items; track s.code) {
									<mat-checkbox [formControlName]="s.code" color="primary">
										{{ s.description }}
									</mat-checkbox>
								}
							</div>
						</div>
						<!-- Right (single column, <= 4 items) -->
						<div>
							<div class="mb-2 font-semibold">{{ secondGroupTitle }}</div>
							<div class="flex flex-col gap-3">
								@for (s of sessionGroups[1].items; track s.code) {
									<mat-checkbox [formControlName]="s.code" color="primary">
										{{ s.description }}
									</mat-checkbox>
								}
							</div>
						</div>
						<div>
							<div class="mb-2 font-semibold">Other</div>
							<div class="flex flex-col gap-3">
								<mat-checkbox formControlName="not_required" color="primary">
									{{ "Not required" }}
								</mat-checkbox>
							</div>
						</div>
					</div>
				} @else if (sessionGroups.length === 3 && !twoGroupsCompact) {
					<div class="grid grid-cols-1 gap-x-12 gap-y-6 sm:grid-cols-4 lg:grid-cols-4">
						<div>
							<div class="mb-2 font-semibold">{{ twoColsLeft?.key }}</div>
							<div class="flex flex-col gap-3">
								@for (s of twoColsLeft?.items; track s.code) {
									<mat-checkbox [formControlName]="s.code" color="primary">
										{{ s.description }}
									</mat-checkbox>
								}
							</div>
						</div>

						@for (col of twoColsRight; track $index) {
							<div>
								@if ($index === 0) {
									<div class="mb-2 font-semibold">{{ secondGroupTitle }}</div>
								} @else {
									<div class="mb-2">&nbsp;</div>
								}
								<div class="flex flex-col gap-3">
									@for (s of col; track s.code) {
										<mat-checkbox [formControlName]="s.code" color="primary">
											{{ s.description }}
										</mat-checkbox>
									}
								</div>
							</div>
						}
						<div>
							<div class="mb-2 font-semibold">Other</div>
							<div class="flex flex-col gap-3">
								<mat-checkbox formControlName="not_required" color="primary">
									{{ "Not required" }}
								</mat-checkbox>
							</div>
						</div>
					</div>
				} @else if (sessionGroups.length === 4 && !twoGroupsCompact) {
					<div class="grid grid-cols-1 gap-x-12 gap-y-6 sm:grid-cols-4 lg:grid-cols-6">
						<div>
							<div class="mb-2 font-semibold">{{ twoColsLeft?.key }}</div>
							<div class="flex flex-col gap-3">
								@for (s of twoColsLeft?.items; track s.code) {
									<mat-checkbox [formControlName]="s.code" color="primary">
										{{ s.description }}
									</mat-checkbox>
								}
							</div>
						</div>

						@for (col of twoColsRight; track $index) {
							@if (col.length > 0) {
								<div>
									@if ($index === 0) {
										<div class="mb-2 font-semibold">{{ secondGroupTitle }}</div>
									} @else {
										<div class="mb-2">&nbsp;</div>
									}
									<div class="flex flex-col gap-3">
										@for (s of col; track s.code) {
											<mat-checkbox [formControlName]="s.code" color="primary">
												{{ s.description }}
											</mat-checkbox>
										}
									</div>
								</div>
							}
						}

						@for (col of lastCols; track $index) {
							<div>
								@if ($index === 0) {
									<div class="mb-2 font-semibold">{{ lastColTitle }}</div>
								} @else {
									<div class="mb-2">&nbsp;</div>
								}
								<div class="flex flex-col gap-3">
									@for (s of col; track s.code) {
										<mat-checkbox [formControlName]="s.code" color="primary">
											{{ s.description }}
										</mat-checkbox>
									}
								</div>
							</div>
						}
						<div>
							<div class="mb-2 font-semibold">Other</div>
							<div class="flex flex-col gap-3">
								<mat-checkbox formControlName="not_required" color="primary">
									{{ "Not required" }}
								</mat-checkbox>
							</div>
						</div>
					</div>
				} @else if (sessionGroups.length >= 5) {
					<div class="grid grid-cols-1 gap-x-12 gap-y-6 sm:grid-cols-2 lg:grid-cols-3">
						@for (g of sessionGroups; track g.code) {
							<div>
								<div class="mb-2 font-semibold">{{ g.key }}</div>
								<div class="flex flex-col gap-3">
									@for (s of g.items; track s.code) {
										<mat-checkbox [formControlName]="s.code" color="primary">
											{{ s.description }}
										</mat-checkbox>
									}
								</div>
							</div>
						}
					</div>
				} @else if (sessionGroups.length === 0) {
					<p class="italic text-gray-500">No sessions available.</p>
				}

				<!-- Section error -->
				@if (sessions.hasError("noSessionSelected") && (sessions.touched || createNewForm.touched)) {
					<div class="mt-2 text-sm text-red">Please select at least one session.</div>
				}
			</div>

			@if (isTS1) {
				<section class="ts1-form-section">
					<div class="ts1-form-section__header">Additional Training/Assessment Details</div>
				</section>
				<div class="px-0 py-6 lg:px-6">
					<app-ets1-reminder-notes-config [reminderNotes]="reminderNotes"></app-ets1-reminder-notes-config>
				</div>
			}

			@if (isTS1) {
				<ng-container formArrayName="maneuvers">
					<app-ts1-assessment-config
						[maneuvers]="maneuvers"
						[maneuverOptions]="ts1FormManeuversOptions"
						[formTypeCode]="formType.value?.code ?? formType.value"
						maneuverAction="create-form"
						(addManeuver)="onAddManeuverV2($event)"
						(requestRemoveManeuver)="onRemoveManeuverV2($event)"
					></app-ts1-assessment-config>
				</ng-container>
			} @else {
				<!-- Assessment Configuration -->
				<section class="ts1-form-section">
					<div class="ts1-form-section__header">Assessment Configuration</div>
				</section>
				<!-- DRAGGABLE only for TS-1 -->
				<ng-container formArrayName="maneuvers">
					@if (maneuvers.length > 0) {
						<mat-accordion
							[multi]="true"
							cdkDropList
							[cdkDropListData]="maneuvers.controls"
							(cdkDropListDropped)="onDropManeuver($event)"
							[cdkDropListDisabled]="!isTS1"
						>
							@for (m of maneuvers.controls; track $index; let i = $index) {
								<mat-expansion-panel
									class="mat-elevation-z1 maneuver-expansion-panel"
									[expanded]="true"
									cdkDrag
									[cdkDragDisabled]="!isTS1"
								>
									<!-- Header -->
									@if (!isTS6 && !isTS1 && !isCabinCrew && !isCabinCrewInstructor) {
										<mat-expansion-panel-header #panelH class="high">
											<div class="ml-4">
												{{ $safeNavigationMigration(fixedManeuvers[i]?.subDescription) | uppercase }}
												<span class="ml-5">
													<span class="text-lg font-bold">&nbsp;&#183;&nbsp;</span>
													{{ fixedManeuvers[i]?.description }}
												</span>
											</div>
										</mat-expansion-panel-header>
									} @else if (isTS1 && ts1FormManeuversOptions.length > 0) {
										<mat-expansion-panel-header #panelH class="maneuver-title high" cdkDragHandle>
											<mat-panel-title class="mat-panel-inner-title w-full">
												<div class="mt-6 flex justify-between" (click)="panelH._toggle()">
													<app-cbta-autocomplete
														[label]="'Select Maneuver'"
														[placeholder]="'Select Maneuver'"
														[data]="maneuvers.at(i).get('maneuver')?.value ?? null"
														[options]="ts1FormManeuversOptions"
														[useFuzzySearch]="true"
														(focusOut)="saveManeuver(i, $event, panelH)"
														[field]="maneuvers.at(i).get('maneuver')!"
														[panelWidth]="500"
													></app-cbta-autocomplete>

													<span
														class="ml-[20px] mt-[25px] flex h-[40px] flex-1 items-center justify-end text-[40px] font-bold italic text-violet"
													>
														{{ i + 1 }}
													</span>
												</div>
											</mat-panel-title>
											@if (maneuvers.length > 1) {
												<mat-panel-description class="flex justify-end">
													<div
														class="h-[28px] w-[28px] rounded-md bg-red text-center text-white"
														(click)="$event.stopPropagation(); removeManeuver(i)"
													>
														<mat-icon class="!leading-6">remove</mat-icon>
													</div>
												</mat-panel-description>
											}
										</mat-expansion-panel-header>
									}

									@if (isTS6) {
										<p class="!m-3">Please Select OB's :</p>
									}

									<!-- Body -->
									@if (isCabinCrew || isCabinCrewInstructor) {
										<app-maneuver-form
											[expensionShow]="true"
											maneuverAction="create-form"
											[isManeuverVisible]="false"
											[maneuverForm]="$any(maneuvers.at(i))"
										>
										</app-maneuver-form>
									} @else {
										<app-maneuver-form
											[expensionShow]="showExpansion($any(maneuvers.at(i)))"
											maneuverAction="create-form"
											[isManeuverVisible]="false"
											[maneuverForm]="$any(maneuvers.at(i))"
										>
										</app-maneuver-form>
									}
								</mat-expansion-panel>
							}
						</mat-accordion>
					} @else {
						<div class="p-6 italic text-gray-500">No maneuvers available.</div>
					}
				</ng-container>
			}
		}

		<div
			class="form-actions my-6 flex flex-row gap-4 border-t pt-6"
			[class.border-grey-20]="isTS1"
			[class.border-blue-light]="!isTS1"
		>
			<button class="aa-btn min-w-24" data-variant="tertiary" (click)="goBack()">Cancel</button>
			<div class="flex-1"></div>
			<button class="aa-btn min-w-24" data-variant="primary" type="button" (click)="onSubmit()">Save</button>
		</div>

		@if (formErrorMessage) {
			<div class="bg-red-light p-3 text-red">{{ formErrorMessage }}</div>
		}
		@if (formSuccess) {
			<div class="bg-green-light p-3 text-green">Form saved sucessfully!</div>
		}
	</form>
}
